import * as React from "react";

import {cx}              from "emotion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSlash}         from '@fortawesome/free-solid-svg-icons';

import "./enlarged-view.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {ComponentNext, Link}    from "@Common/react/cst2";
import {GlobalKeys}             from "@Common/react/global-keys-react";
import {Load2}                  from "@Common/react/load2";
import {UseState}               from "@Common/react/use-state";
import {isIe, isEdge}           from "@Common/ui-components/debug/is-ie-edge-or-firefox";
import {DeprecatedModalService} from "@Common/ui-components/modal-service/modal-service";

import {decreaseGallery, increaseGallery} from "@Xpresso/routes/customize/steps/product-options/template-selection-template-view/front-template-viewer/front-template-viewer";

import {TemplateSvgThumbnail} from "../components/template-svg-thumbnail/template-svg-thumbnail";

export const EnlargedView = ({images, modalState, next: rootNext, onChangeView, viewing, gallery=null}:{
        next : Link<JSX.Element, {
        show : () => void,
    }>,
    images        : Array<{path: string} | {url: string}>,
    modalState   ?: ComponentNext<typeof UseState<{show: boolean}>>,
    onChangeView  : (index:number) => void,
    viewing       : number, // image index
    gallery      ?: any,
}) => cs(
    ["modal", ({}) => DeprecatedModalService({
        top: 50,
        hideCloseButton: true,
        noFrame: true,
        render: ({}, rm) => ({
            content:
                EnlargedViewPopupContent({
                    images,
                    gallery,
                    viewing,
                    onChangeView,
                    close: () => rm(),
                }),
        }),
        state: modalState,
        next: rootNext
    })],
);


const EnlargedViewPopupContent = ({images, viewing, onChangeView, close, gallery=null}) => cs(
    consumeContext("themeScheme"),
    consumeContext("svgThumbnailsCache"),
    ["url", (_, next) => next(images[viewing].url || images[viewing].path)],
    ["svgCodeLoad", ({svgThumbnailsCache: {loadUrl}, url}, next) => Load2({
        next,
        fetch: async () => url.endsWith(".svg") ? loadUrl(url) : null,
    })],
    ({themeScheme, svgCodeLoad: {value: svgCode}, url}) => (
        <div
            className={cx("enlarged-view enlarged-view-pop-9y7", {"ie": isIe(), "edge": isEdge(), svg: !!svgCode})}
            xd-qa-type="modal"
            xd-qa-name="Enlarged View Modal"
        >
            <GlobalKeys {...{
                keyCombo: "Escape",
                onKeyDown: close,
            }} />
            <GlobalKeys {...{
                keyCombo: "ArrowLeft",
                onKeyDown: () => {
                    onChangeView((viewing - 1) < 0 ? images.length - 1 : (viewing - 1))
                    if(gallery) {
                        decreaseGallery(gallery, images, viewing)
                    }
                },
            }} />
            <GlobalKeys {...{
                keyCombo: "ArrowRight",
                onKeyDown: () => {
                    onChangeView((viewing + 1) >= images.length ? 0 : (viewing + 1))
                    if(gallery) {
                        increaseGallery(gallery, images, viewing)
                    }
                },
            }} />
            <div className="template-back">
                {svgCode ? (
                    <TemplateSvgThumbnail svgCode={svgCode}/>
                ) : (
                    <img
                        src={url}
                        alt={"Template Back " + (viewing + 1)}
                        xd-qa-type="image"
                        xd-qa-name={"Image " + (viewing + 1)}
                    />
                )}
                {images?.length > 1 && viewing !== 0 && (
                    <button
                        className={"left-button"}
                        style={{backgroundColor: themeScheme.xpresso.menuBackgroundColor, color: themeScheme.xpresso.headerColor}}
                        onClick={(e) => {
                            e.stopPropagation();
                            const newIndex = viewing - 1;
                            onChangeView(newIndex < 0 ? images.length - 1 : newIndex);
                            if(gallery) {
                                decreaseGallery(gallery, images, viewing)
                            }
                        }}
                        xd-qa-type="Button"
                        xd-qa-name="Left"
                    >
                        <i className="fa fa-chevron-left" style={{color: themeScheme.xpresso.menuTextColor}}/>
                    </button>
                )}
                <button
                    className="close-btn"
                    style={{backgroundColor: themeScheme.xpresso.menuBackgroundColor, color: themeScheme.xpresso.headerColor}}
                    xd-qa-type="icon"
                    xd-qa-name="close"
                    onClick={() => {
                        close();
                    }}
                >
                    <span className="fa-layers fa-fw">
                        <FontAwesomeIcon className="icon1" icon={faSlash} color={themeScheme.xpresso.menuTextColor} flip={"horizontal"}/>
                        <FontAwesomeIcon className="icon2" icon={faSlash} color={themeScheme.xpresso.menuTextColor}/>
                    </span>
                </button>
                {images?.length > 1 && viewing !== (images?.length - 1) && (
                    <button
                        className="right-button"
                        style={{backgroundColor: themeScheme.xpresso.menuBackgroundColor, color: themeScheme.xpresso.headerColor}}
                        onClick={(e) => {
                            e.stopPropagation();
                            const newIndex = viewing + 1;
                            onChangeView(newIndex >= images.length ? 0 : newIndex);
                            if(gallery) {
                                increaseGallery(gallery, images, viewing)
                            }
                        }}
                        xd-qa-type="Button"
                        xd-qa-name="Right"
                    >
                        <i className="fa fa-chevron-right" style={{color: themeScheme.xpresso.menuTextColor}}/>
                    </button>
                )}
            </div>
        </div>
    ),
);
